(() => {
  'use strict';
  const card = document.getElementById('mzs-telefoonapp');
  const dialog = document.getElementById('mzs-app-dialog');
  if (!card || !dialog || card.dataset.initialized) return;
  card.dataset.initialized = 'true';
  const standalone = window.matchMedia('(display-mode: standalone)');
  const appOpeners = document.querySelectorAll('[data-mzs-app-open]');
  const hideWhenInstalled = () => {
    const installed = standalone.matches || navigator.standalone === true;
    card.hidden = installed;
  };
  hideWhenInstalled();
  standalone.addEventListener?.('change', hideWhenInstalled);
  let installPrompt = null;
  let opener = null;
  const installButton = dialog.querySelector('.mzs-app-dialog__install');
  const status = dialog.querySelector('[role="status"]');
  const ua = navigator.userAgent;
  const ios = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  const android = /Android/i.test(ua);
  const deviceChoices = dialog.querySelectorAll('[data-mzs-device-choice]');
  const setDevice = (device) => {
    dialog.querySelector('#mzs-install-ios').hidden = device !== 'ios';
    dialog.querySelector('#mzs-install-android').hidden = device !== 'android';
    deviceChoices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mzsDeviceChoice === device)));
    installButton.hidden = !android || device !== 'android' || !installPrompt;
  };
  deviceChoices.forEach(button => button.addEventListener('click', () => setDevice(button.dataset.mzsDeviceChoice)));
  setDevice(android ? 'android' : 'ios');
  dialog.querySelector('.mzs-install-desktop').hidden = ios || android;
  if (typeof dialog.showModal === 'function') {
    card.querySelector('.mzs-app__fallback').hidden = true;
    appOpeners.forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      opener = event.currentTarget;
      dialog.showModal();
      document.documentElement.classList.add('mzs-app-lock');
    }));
    const close = () => dialog.close();
    dialog.querySelector('.mzs-app-dialog__close').addEventListener('click', close);
    dialog.querySelector('[data-mzs-app-dismiss]').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('mzs-app-lock');
      opener?.focus();
    });
  } else {
    appOpeners.forEach(link => link.addEventListener('click', () => { card.querySelector('details').open = true; }));
  }
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    installPrompt = event;
    installButton.hidden = !android || dialog.querySelector('[data-mzs-device-choice="android"]').getAttribute('aria-pressed') !== 'true';
  });
  installButton.addEventListener('click', async () => {
    if (!installPrompt) return;
    const prompt = installPrompt;
    installPrompt = null;
    installButton.disabled = true;
    try {
      await prompt.prompt();
      const choice = await prompt.userChoice;
      status.textContent = choice.outcome === 'accepted' ? 'Je installatie is aangevraagd. Volg de melding van je telefoon.' : 'Geen probleem. Je kunt MZS later alsnog toevoegen via het menu van je browser.';
    } catch (_) {
      status.textContent = 'Gebruik de stappen hieronder om MZS via je browser toe te voegen.';
    } finally {
      status.hidden = false;
      installButton.hidden = true;
      installButton.disabled = false;
    }
  });
  window.addEventListener('appinstalled', () => {
    installPrompt = null;
    installButton.hidden = true;
    card.hidden = true;
    status.hidden = false;
    status.textContent = 'MZS is toegevoegd. Je vindt het icoon op je beginscherm.';
  });
})();

